import { Alert, Table } from 'antd';
import React from 'react';

import * as accessPointColumns from '../../../AccessPoint/columns';
import { AccessPointModel } from '../../../AccessPoint/model';
import {
  EmergencyPlanWithIcon,
} from '../../../EmergencyScenarioAccessPoint/components/EmergencyPlanWithIcon';

import type { AccessPointWithEmergencyPlan } from './formatAccessPointsWithEmergencyPlan';

interface IEmergencyScenarioAccessPointsTableProps {
  accessPoints: AccessPointWithEmergencyPlan[];
  selectedRowKeys: string[];
  setSelectedRowKeys: (keys: string[]) => void;
  loading?: boolean;
  readOnly?: boolean;
}

export const EmergencyScenarioAccessPointsTable: React.FC<
  IEmergencyScenarioAccessPointsTableProps
> = (props) => {
  const {
    accessPoints, selectedRowKeys, setSelectedRowKeys, loading, readOnly,
  } = props;

  return (
    <Table
      loading={loading}
      dataSource={accessPoints}
      pagination={false}
      rowKey={(a) => a.accessPointId}
      columns={[
        {
          title: 'Name',
          render: (_, accessPoint) => AccessPointModel.routes.renderRowLink(accessPoint),
        },
        {
          title: 'Image',
          render: (_, accessPoint) => accessPointColumns.imageColumn.render(accessPoint),
        },
        {
          title: 'Type',
          render: (_, accessPoint) => accessPointColumns.typeColumn.render(accessPoint as any),
        },
        {
          title: 'Total Relays',
          render: (_, { totalRelays }) => totalRelays,
        },
        {
          title: 'Emergency Plan',
          render: (_, { emergencyScenarioAccessPoint }) => {
            if (!emergencyScenarioAccessPoint) {
              return 'None';
            }

            return (
              <EmergencyPlanWithIcon emergencyPlan={emergencyScenarioAccessPoint.emergencyPlan} />
            );
          },
        },
        {
          render: (_, { alerts }) => {
            return (
              <>
                {alerts.map((alertProps, index) => (
                  <Alert
                    {...alertProps}
                    key={index}
                    style={{
                      marginBottom: alerts.length > 1 && index !== (alerts.length - 1) ? 10 : 0,
                    }}
                  />
                ))}
              </>
            );
          },
        },
      ]}
      onRow={({ accessPointId }) => {
        return {
          onClick: () => {
            if (!selectedRowKeys.includes(accessPointId)) {
              setSelectedRowKeys([...selectedRowKeys, accessPointId]);
            } else {
              setSelectedRowKeys(selectedRowKeys.filter(k => k !== accessPointId));
            }
          },
        };
      }}
      rowSelection={!readOnly ? {
        selectedRowKeys,
        onSelect: ({ accessPointId }, selected) => {
          if (selected) {
            setSelectedRowKeys([...selectedRowKeys, accessPointId]);
          } else {
            setSelectedRowKeys(selectedRowKeys.filter(k => k !== accessPointId));
          }
        },
        onSelectAll: (selected, selectedAccessPoints) => {
          if (selected) {
            setSelectedRowKeys(selectedAccessPoints.map(a => a.accessPointId));
          } else {
            setSelectedRowKeys([]);
          }
        },
      } : undefined}
      rowClassName={() => !readOnly ? 'selectable-row' : ''}
      style={{ marginBottom: 40 }}
    />
  );
};
